import { Component, ReactNode, ErrorInfo } from 'react';
import { logger } from '@fiverr-private/obs';

interface ErrorBoundaryProps {
  children: ReactNode;
}

class ErrorBoundary extends Component<NonNullable<unknown>, { hasError: boolean }> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  public override componentDidCatch(error: Error, _: ErrorInfo) {
    logger.error(error, { description: 'Failed to load/run Reviews component' });
  }

  public override render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
